type RuntimeConfig = {
  BUILD_TYPE?: string;
  AUTH_URL?: string;
  API_URL?: string;
  CAPTCHA_KEY?: string;
  FACEBOOK_URL?: string;
  LINKEDIN_URL?: string;
  SITEMAP_BASE_URL?: string;
  BASE_URL?: string;
  GEO_WIDGET_WFS_URL: string;
  GEO_WIDGET_WFS_NAMESPACE: string;
  GA_MEASUREMENT_ID?: string;
  WLAS_BASE_URL?: string;
};

// Always read from window.RUNTIME_CONFIG at call time — never cache at module load,
// because the runtime-config script may not have executed yet when this module is first imported.
export const runtimeConfig: RuntimeConfig = new Proxy({} as RuntimeConfig, {
  get(_target, prop: string) {
    if (typeof window === 'undefined') return undefined;
    return (window.RUNTIME_CONFIG as Record<string, unknown>)?.[prop];
  },
});
